/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import Component from '@ember/component';
import { service } from '@ember/service';

export default class AchievementChip extends Component {
  // Services
  @service
  dates;

  @service
  session;

  @service
  store;

  assessor = null;
  average = '';
  currentMilestone = '';
  levels = null;
  person = null;
  statementData = null;
  subject = null;
}
